module.exports = __webpack_public_path__ + "media/recipes/149-8d94bcd4.png";